import { appConfig } from '../../constants/app-config';

export const checkEmailServiceModule = angular
  .module('Q.services.check-email-service', [])
  .factory('checkEmailService', function ($http) {
    return {
      check(email, type) {
        return $http
          .post(
            appConfig.apiRoot + 'account/precheck',
            {
              data: {
                $type: type,
                email: email,
              },
            },
            {
              ignoreLoadingBar: true,
            },
          )
          .then(function (res) {
            let data = res.data;
            return (data && data.data) || {};
          })
          .catch(function () {
            return {};
          });
      },
    };
  });
